module.exports = __webpack_public_path__ + "static/danse_macabre-65c3fb7e312707b08b00630ae283ab2b.jpg";